<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Clip（クリップ）| お気に入りのコンテンツをあなたの手元に。",
    meta: [
      {
        vmid: "og_site_name",
        property: "og:site_name",
        content:
          "Clip（クリップ）| お気に入りのコンテンツをあなたの手元に。お気に入り記事を分類＆要約できる新しいブックマークサービス"
      },
      {
        vmid: "og_title",
        property: "og:title",
        content:
          "Clip（クリップ）| お気に入りのコンテンツをあなたの手元に。お気に入り記事を分類＆要約できる新しいブックマークサービス"
      },
      {
        vmid: "og_description",
        property: "og:description",
        content:
          "あのコンテンツ、を手元に。Clip（クリップ）は、お気に入り記事を分類＆要約できる、効率化時代の新ブックマークサービスです。"
      },
      {
        vmid: "og_type",
        property: "og:type",
        content: "website"
      },
      {
        vmid: "og_url",
        property: "og:url",
        content: "https://web-clipper.com/"
      },
      {
        vmid: "og_image",
        property: "og:image",
        content: "https://web-clipper.com/image/ogp.png?v=2"
      },
      {
        vmid: "description",
        name: "description",
        content:
          "あのコンテンツ、を手元に。Clip（クリップ）は、お気に入り記事を分類＆要約できる、効率化時代の新ブックマークサービスです。"
      },
      {
        name: "keywords",
        content: "Clip,クリップ,ブックマーク,要約,分類"
      },
      {
        name: "twitter:card",
        content: "summary_large_image"
      }
    ]
  },
  mounted() {
    let url = new URL(location.href);
    if (url.searchParams.get("lang")) {
      this.$i18n.locale = url.searchParams.get("lang");
      localStorage.setItem("clip-lang", this.$i18n.locale);
    }
    var el = document.getElementsByTagName("html");
    el[0].setAttribute("lang", this.$i18n.locale);
  }
};
</script>
